import React from 'react';
import { Check } from 'lucide-react';

const MOBILE_BLOCKS = [
  {
    img: 'https://restaff.b-cdn.net/Screenshots/Quick%20Clock%20Mobile.png',
    alt: 'Mobile Quick Clock — clock in and out from any device with ReStaff',
    title: 'Mobile Quick Clock',
    desc: 'Employees can clock in and out from mobile devices while managers track attendance in real time.',
    bullets: ['Works on any device', 'No app installation required', 'Secure PIN or QR access'],
    reverse: false,
  },
  {
    img: 'https://restaff.b-cdn.net/Screenshots/Install%20the%20App.jpg',
    alt: 'Install ReStaff as a Progressive Web App on any device',
    title: 'Native App Experience',
    desc: 'Install ReStaff as a Progressive Web App on desktop or mobile. Runs like a native app — without app store approval or updates.',
    bullets: ['Install on iOS & Android', 'Works on desktop', 'No app store required'],
    reverse: true,
  },
];

export function MobileAppSection() {
  return (
    <section className="py-12 md:py-24 bg-slate-50" aria-label="Mobile and App Experience">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        <div className="text-center mb-10 md:mb-20">
          <h2
            className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight"
            style={{ fontFamily: 'Manrope' }}
          >
            Manage Your Team<br className="hidden sm:block" /> From Anywhere
          </h2>
          <p className="mt-5 text-lg md:text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Access scheduling, attendance, and workforce tools on any device — instantly.
          </p>
        </div>

        <div className="space-y-8 md:space-y-12 lg:space-y-32">
          {MOBILE_BLOCKS.map((block, i) => (
            <React.Fragment key={block.title}>
              <div className={`flex flex-col ${block.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-6 md:gap-12 lg:gap-16 items-center`}>
                <div className="w-full lg:w-[30%] flex-shrink-0">
                  <img
                    src={block.img}
                    alt={block.alt}
                    loading="lazy"
                    width="960"
                    height="620"
                    className="w-full rounded-2xl shadow-2xl border border-slate-100"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3
                    className="text-3xl md:text-4xl font-bold text-slate-900 mb-5 leading-tight"
                    style={{ fontFamily: 'Manrope' }}
                  >
                    {block.title}
                  </h3>
                  <p className="text-slate-600 text-lg leading-relaxed mb-8">{block.desc}</p>
                  <ul className="space-y-4">
                    {block.bullets.map((bullet) => (
                      <li key={bullet} className="flex items-center gap-3">
                        <span className="w-6 h-6 rounded-full bg-orange-100 border border-orange-200 flex items-center justify-center flex-shrink-0">
                          <Check size={12} className="text-orange-600" strokeWidth={3} />
                        </span>
                        <span className="text-slate-800 text-base font-semibold">{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {i < MOBILE_BLOCKS.length - 1 && <div className="border-t border-slate-200" />}
            </React.Fragment>
          ))}
        </div>

      </div>
    </section>
  );
}
